import { get } from 'lodash';
import { useQuery } from 'urql';

import {
  selectImpersonationOverrides,
  useGetLoggedInUser,
  useImpersonationSelector,
} from '@revelio/auth';
import {
  GetClientDetailsDocument,
  type PipelineClientConfig,
} from '@revelio/data-access';

export const useClientDataBuilderConfig = (): PipelineClientConfig | null => {
  const { loggedInUser } = useGetLoggedInUser();
  const overrides = useImpersonationSelector(selectImpersonationOverrides);
  const [{ data: clientData }] = useQuery({
    query: GetClientDetailsDocument,
    variables: { ids: [loggedInUser?.client_name as string] },
    pause: !loggedInUser?.client_name,
  });
  const clientConfig = get(
    clientData,
    'clients[0].data_builder_configuration',
    null
  ) as PipelineClientConfig | null;
  if (!clientConfig) {
    return null;
  }

  return {
    ...clientConfig,
    pipeline_type:
      overrides?.pipelineTypes !== undefined
        ? overrides.pipelineTypes
        : clientConfig.pipeline_type,
    posting_source:
      overrides?.postingSources !== undefined
        ? overrides.postingSources
        : clientConfig.posting_source,
  };
};
